import React from 'react'
export default function PopUp(props){
    return(
        <>
        <div id="myModal" className="modal">
            <div className="modal-content">
                {props.children}
            </div>

        </div>
        </>
    )
}